import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { EFormularInputType } from "../../formular-model/formular-groups/interfaces/FormularGroupInputs";


@Component({
  selector: "formular-tab-content-base-class",
  template: "",
  styles: [""],
  standalone: false,
})
export class FormularGroupTabContentComponent<TData = unknown> {
  @Input() data!: TData;
  @Input() form!: FormGroup;

  __dataInternal!: TData;

  public formularGroupDataKey!: string;

  public _reportError?: (e: Error) => void;

  public reconstructData() {
    throw new Error(
      `Reconstruct data not implemented on class ${this.constructor.name}`,
    );
  }
    getInputString(type: number): string {
      return EFormularInputType[type];
    }

  public inputTypeToHtmlType(value: string): string | null {
    switch (value?.toLowerCase()) {
      case "entry":
      case "singleline":
      case "text":
        return "text";
      case "editor":
      case "multiline":
        return "textarea";
      case "checkbox":
        return "checkbox";
      case "date":
        return "date";
      case "time":
        return "time";
      case "datetime":
      case "datetimepicker":
        return "datetime-local";
      case "comboexistingvalues":
        return "select";
      default:
        return "text";
    }
  }

  public stringify(obj: object) {
    return JSON.stringify(obj);
  }
}
